import { render, staticRenderFns } from "./BaseSmoothScrollbar.vue?vue&type=template&id=6f9bbab8&"
import script from "./BaseSmoothScrollbar.vue?vue&type=script&lang=js&"
export * from "./BaseSmoothScrollbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports